import Model from './Model'

export default class ProductCategory extends Model {
  resource () {
    return 'product-categories'
  }
}
